import { useState } from "react";
import { api } from "@/lib/api";

export default function HQLookup() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [detail, setDetail] = useState(null);

  const search = async () => {
    if (q.trim().length < 2) return;
    const r = await api.get(`/hq/lookup?q=${encodeURIComponent(q)}`);
    setRes(r.data); setDetail(null);
  };

  const openUser = async (uid) => {
    const r = await api.get(`/hq/users/${uid}`);
    setDetail(r.data);
  };

  return (
    <div className="p-6" data-testid="hq-lookup">
      <p className="overline">Global lookup</p>
      <h1 className="font-display text-3xl tracking-tighter mb-4">Lookup</h1>
      <p className="text-xs text-cream/60 mb-4">Search booking id, studio, professional, member, after-hours request, safety report.</p>

      <div className="flex gap-2 mb-6">
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
               placeholder="ben, steve, booking id…"
               data-testid="hq-lookup-input"
               className="flex-1 bg-transparent border border-cream/15 px-3 py-2 text-cream focus:border-gold outline-none" />
        <button data-testid="hq-lookup-search" onClick={search} className="btn-gold px-4 py-2 rounded-full text-[10px] uppercase tracking-[0.2em] font-semibold">Search</button>
      </div>

      {res && (
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div className="border border-cream/10 p-4" data-testid="hq-lookup-users">
              <p className="overline mb-2">Users ({res.users.length})</p>
              {res.users.map((u) => (
                <button key={u.id} onClick={() => openUser(u.id)} data-testid={`hq-lookup-user-${u.id}`} className="block w-full text-left border-b border-cream/10 py-2 last:border-b-0 text-xs hover:text-gold">
                  {u.name} · <span className="text-cream/60">{u.email}</span> · <span className="text-[10px] uppercase tracking-[0.2em]">{u.role}</span>
                </button>
              ))}
            </div>
            <div className="border border-cream/10 p-4" data-testid="hq-lookup-studios">
              <p className="overline mb-2">Studios ({res.studios.length})</p>
              {res.studios.map((s) => <p key={s.id} className="text-xs border-b border-cream/10 py-2 last:border-b-0">{s.name} · <span className="text-cream/60">{s.area}, {s.city}</span></p>)}
            </div>
            <div className="border border-cream/10 p-4" data-testid="hq-lookup-bookings">
              <p className="overline mb-2">Bookings ({res.bookings.length})</p>
              {res.bookings.map((b) => <p key={b.id} className="text-xs border-b border-cream/10 py-2 last:border-b-0 font-mono">{b.id.slice(0, 8)}… · {b.member_name} → {b.studio_name} · {b.status}</p>)}
            </div>
          </div>
          <div>
            {detail ? (
              <div className="border border-cream/10 p-5" data-testid="hq-lookup-detail">
                <p className="overline">{detail.role} operational view</p>
                <h2 className="font-display text-2xl mt-1">{detail.name}</h2>
                <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50">{detail.email}</p>
                {detail.operational?.studio && (
                  <div className="mt-4 border-t border-cream/10 pt-3">
                    <p className="text-xs text-cream/70">Studio: {detail.operational.studio.name}</p>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50">Verified cuts: {detail.operational.completed_cuts} · Rating: {detail.operational.rating}</p>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50">Earnings via KUTZ: ${detail.operational.gross_earnings_via_kutz}</p>
                  </div>
                )}
                {detail.operational?.completed_bookings !== undefined && (
                  <div className="mt-4 border-t border-cream/10 pt-3">
                    <p className="text-xs">Completed bookings: {detail.operational.completed_bookings}</p>
                    <p className="text-[10px] text-cream/60">Late cancellations: {detail.operational.late_cancellations} · No-shows: {detail.operational.no_shows}</p>
                    <p className="text-[10px] text-cream/60">Reports raised by user: {(detail.operational.reports_by || []).length}</p>
                    <p className="text-[10px] text-cream/60 mt-1">Not a public "bad customer score" — internal operations only.</p>
                  </div>
                )}
                <div className="mt-4 border-t border-cream/10 pt-3">
                  <p className="overline mb-2">Recent bookings</p>
                  {(detail.operational?.recent_bookings || []).map((b) => (
                    <p key={b.id} className="text-[10px] border-b border-cream/10 py-1 last:border-b-0">
                      {new Date(b.start_time).toLocaleDateString()} · {b.studio_name} · <span className="text-cream/60">{b.status}</span>
                    </p>
                  ))}
                </div>
              </div>
            ) : (
              <p className="text-cream/50 text-xs">Select a user to view operational context.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
